export default __webpack_public_path__ + "static/media/Shadowed Valleys-28.a43147f0.jpg";